<template>
  <div>
    <b-modal
      v-model="showModal"
      class="mc-modal"
      id="modal-form"
      :title="title"
      size="xl"
      centered
      :hide-header-close="loading"
      no-close-on-backdrop
      style="max-width: 100%"
    >
      <div class="card-body mc-modal__filter p-2">
        <!-- Filter & Search -->
        <div class="clearfix">
          <div class="float-start">
            <date-picker
              v-model="periode"
              placeholder="Pilih Tanggal"
              format="DD MMM YYYY"
              value-type="YYYY-MM-DD"
            />
          </div>
          <div class="float-end">
            <div class="mc-table-view">
              <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                <label class="d-inline-flex align-items-center mc-table-view__search">
                  <i class="mc-fa fas fa-search"></i>
                  <b-form-input
                    v-model="filter"
                    type="search"
                    :placeholder="$t('global.search') + '...'"
                    class="ms-2"
                    @input="onSearchInput"
                  />
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabel -->
        <div class="table-responsive mb-3 my-3 border border-1 align-middle">
          <div
            v-if="loading"
            style="display: flex; justify-content: center; align-items: center; height: 20vh"
          >
            <b-spinner variant="primary" size="lg" label="Loading..." />
          </div>

          <div v-else-if="dataCommand.data && dataCommand.data.length > 0">
            <b-table
              class="datatables"
              :items="dataCommand.data"
              responsive="xl"
              :filter="filter"
              show-empty
              :empty-text="$t('global.emptyTable')"
              :fields="fields"
              :empty-filtered-text="$t('global.emptyFilteredTable')"
            >
              <template #cell(created_on)="{ item }">
                <p>
                  <span>{{ parseDate(item.created_on) }}</span>
                </p>
              </template>
            </b-table>
          </div>

          <div
            v-else
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              height: 20vh;
              color: #6c757d;
              font-size: 1.2rem;
            "
          >
            ⚠️ Tidak ada data
          </div>
        </div>

        <!-- Pagination -->
        <div v-if="dataCommand.data && dataCommand.data.length > 0">
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  Menampilkan
                  <b-form-select
                    class="form-select form-select-sm"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                    @change="resetFilter"
                  />
                  entri. Menampilkan&nbsp;
                  <strong>
                    {{
                      dataCommand.data?.length > 0
                        ? (dataCommand.page - 1) * dataCommand.size + 1
                        : 0
                    }}
                  </strong>
                  &nbsp;sampai&nbsp;
                  <strong>
                    {{
                      dataCommand.page != dataCommand.total_pages
                        ? Math.min(dataCommand.total_count, dataCommand.page * dataCommand.size)
                        : (dataCommand.page - 1) * dataCommand.size + dataCommand.data.length
                    }}
                  </strong>
                  &nbsp;dari&nbsp;
                  <strong>
                    {{ dataCommand.total_count }}
                  </strong>
                  &nbsp;entri.
                </label>
              </div>
            </div>
            <div class="col-sm-12 col-md-6">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination
                    v-model="dataCommand.page"
                    :total-rows="dataCommand.total_count"
                    :per-page="dataCommand.size"
                    @change="changePage"
                  />
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template #modal-footer>
        <b-row class="mc-modal__filter-footer">
          <b-col cols="12" class="mc-modal__filter-footer-btn">
            <b-button @click="closeModal" variant="primary">Close</b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    region: { type: String, default: 'SG' },
    title: { type: String, default: 'Alert Data' },
    message: { type: String, default: '' },
    modal: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    dataCommand: { type: Object, default: () => ({}) },
  },
  emits: ['set-alert-change', 'filter-change'],
  data() {
    return {
      form: { selected: null },
      modalConfirm: false,
      perPage: 10,
      currentPage: 1,
      pageOptions: [10, 25, 50, 100],
      filteredItems: [],
      totalRows: 10,
      filter: '',
      periode: [],
      fields: [
        { key: 'created_on', label: 'Tanggal' },
        { key: 'description', label: 'Alert' },
        { key: 'imei', label: 'IMEI' },
      ],
    }
  },
  computed: {
    showModal: {
      get() {
        return this.modal
      },
      set(newVal) {
        this.$emit('update:modal', newVal)
      },
    },
    loading: {
      get() {
        return this.isLoading
      },
      set(newVal) {
        this.$emit('update:isLoading', newVal)
      },
    },
  },
  watch: {
    // 🔥 Perbaikan: gunakan watch untuk mendeteksi perubahan periode (termasuk saat dihapus)
    periode(newVal) {
      this.changeDateRange(newVal)
    },
  },
  methods: {
    onSearchInput() {
      this.$emit('filter-change', {
        ...this.dataCommand,
        search: this.filter,
        page: 1,
      })
    },

    changePage(page) {
      this.$emit('set-alert-change', {
        ...this.dataCommand,
        page: page,
        search: this.filter,
      })
    },

    resetFilter(e) {
      this.$emit('set-alert-change', {
        ...this.dataCommand,
        page: 1,
        size: e,
        search: this.filter,
      })
    },

    // 🔥 Perbaikan: tangani array kosong, null, undefined dengan benar
    changeDateRange(e) {
      // Jika e adalah array, cek panjangnya; jika selain array, cek truthy
      const isValid = Array.isArray(e) ? e.length > 0 : !!e

      const payload = {
        ...this.dataCommand,
        page: 1,
        start_date: isValid ? e + ' 00:00:00' : null,
        end_date: isValid ? e + ' 23:59:59' : null,
      }
      this.$emit('set-alert-change', payload)
    },

    closeModal() {
      this.$bvModal.hide('modal-form')
    },

    parseDate(e) {
      const inputDate = new Date(e)
      const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ]
      const addLeadingZero = (v) => (v < 10 ? `0${v}` : v)
      return `${addLeadingZero(inputDate.getDate())} ${
        months[inputDate.getMonth()]
      } ${inputDate.getFullYear()} ${addLeadingZero(inputDate.getHours())}:${addLeadingZero(
        inputDate.getMinutes()
      )}:${addLeadingZero(inputDate.getSeconds())}`
    },
  },
}
</script>
